import qs from 'qs'
import instance from '@/helpers/axios'
import moment from 'moment'
import numeral from 'numeral'

const state = {
    prospect_beginDate: null,
    prospect_lastDate: null,
    prospect_datasets: [],
    //v2
    prospect_isLoading:false,
    prospect_table: null,
    prospect_total: 0,
    prospect_channels: [],

}

// getters
const getters = {
    prospect_date: state => {
        if (state.prospect_beginDate != null) {
            var _start = state.prospect_beginDate.split("T");
            var _end = state.prospect_lastDate.split("T")
            return { start: _start[0], end: _end[0] }
        } else {
            return { start: state.prospect_beginDate, end: state.prospect_lastDate }
        }
    },
    prospect_data_date: state => {
        return state.prospect_beginDate + " and " + state.prospect_lastDate;
    },
    prospect_datasets: state => {
        return state.prospect_datasets;
    },
    prospect_table: state => {
        return state.prospect_table;
    },
}

// actions
const actions = {
    getProspectDatasets(context, payload) {
        state.prospect_isLoading = true;
        state.prospect_country_filter = null;
        const request = {
            params: qs.parse({
                limit: 1,
                sort: "-date"
            })
        };
        instance.get('tourist/prospect', request)
            .then(response => {
                const { rows } = response.data;
                const date = rows.map((item) => { return item.date });
                var _start = moment(new Date(date)).add(-7, 'days');
                var _end = moment(new Date(date));
                var _params = {
                    start: _start.format("YYYY-MM-DD"),
                    end: _end.format("YYYY-MM-DD"),
                    sort: '-date'
                };
                // calulate _params from main_filters                
                var main_filters = payload.main_filters;
                if (main_filters !== null) {
                    if (main_filters.start !== null && main_filters.end !== null) {
                        _start = moment(new Date(main_filters.start));
                        _end = moment(new Date(main_filters.end));
                        _params.start = _start.format("YYYY-MM-DD");
                        _params.end = _end.format("YYYY-MM-DD");
                    }
                    if (main_filters.location_source !== null) {
                        _params.location_source = main_filters.location_source;
                    }
                    if (main_filters.location_destination != null) {
                        _params.location_destination = main_filters.location_destination;
                    }
                }

                // calulate _params from sub_filters
                // prospect_channels, q, limit, page, sort
                _params.limit = 5;
                _params.page = 1;
                var sub_filter = payload.sub_filter;
                if (sub_filter !== null) {

                    if (sub_filter.prospect_channels !== null) {
                        _params.prospect_channels = sub_filter.prospect_channels;
                    }
                    if (sub_filter.q !== "") {
                        _params.q = sub_filter.q;
                    }
                    if (sub_filter.limit > 0) {
                        _params.limit = sub_filter.limit;
                    }
                    if (sub_filter.page > 0) {
                        _params.page = sub_filter.page;
                    }
                    if (sub_filter.sort != "") {
                        _params.sort = sub_filter.sort;
                    }
                }

                state.prospect_beginDate = moment(_start).format("YYYY-MM-DD");
                state.prospect_lastDate = moment(_end).format("YYYY-MM-DD");

                const request = {
                    params: qs.parse(_params)
                };

                instance.get('tourist/prospect', request)
                    .then(response => {
                        const { prospect_channels, count, rows } = response.data;
                        state.prospect_datasets = rows;
                        state.prospect_total = count;
                        state.prospect_channels = prospect_channels;

                        payload.stateDatasets.forEach(function(stateName) {
                            if (stateName == "prospect_table") {
                                context.commit("onProspectTable", payload);
                            }
                        })
                        state.prospect_isLoading = false;
                    })
                    .catch(error => {
                        console.log(error.response, "[store/tourist/prospect] syntax errors under instant.get");
                    })
            })
            .catch(error => {
                console.log(error.response);
            })
    }
}

// mutations
const mutations = {
    onProspectMutations(state, payload) {
        // --- start dataset doughnut for chart        
        // --- end dataset for doughnut chart
    },
    onProspectTable(state, payload) {
        // --- start dataset for v-data-table
        /**
         {
            "id": "5be53e363ea5940006568e49",
            "prospect_channels": "Website",
            "prospect_name": "kd_shoots_with_iphone",
            "prospect_message": "The standard Lorem Ipsum passage, used since the 1500s",
            "location_zone": "เอเชีย",
            "location_source": "จอร์แดน",
            "location_destination": "กาญจนบุรี",
            "location_destination_region": "ภาคกลาง",
            "date": "2018-10-13T00:00:00.000Z"
        }
        */
        var rows = state.prospect_datasets;
        var _prospect_datatable = {
            headers: [
                { text: 'Date', value: "date", align: 'left', style: 'width:120px;' },
                { text: 'Channels', value: "prospect_channels", align: 'left' },
                { text: 'Name', value: "prospect_name", align: 'left' },
                { text: 'Message', value: "prospect_message", align: 'left', sortable: false },
                { text: 'Source', value: "location_source", align: 'left' },
                { text: 'Destination', value: "location_destination", align: 'left' },
            ],
            items: [{
                value: false,
                date: '',
                prospect_channels: '',
                prospect_name: '',
                prospect_message: '',
                location_source: '',
                location_destination: '',
            }],
            pagination: {
                sortBy: 'date',
                descending: false,
            },
            total: 0,
        };

        // build items
        var items = [];
        rows.forEach(function(item, index) {
            var _item = {
                value: false,
                date: item.date,
                prospect_channels: item.prospect_channels,
                prospect_name: item.prospect_name,
                prospect_message: item.prospect_message,
                location_source: item.location_source,
                location_destination: item.location_destination,
            }
            items.push(_item);
        });
        _prospect_datatable.items = items;
        _prospect_datatable.total = state.prospect_total;
        _prospect_datatable.prospect_channels = state.prospect_channels.sort(function(a, b) { return a.localeCompare(b) });
        state.prospect_table = _prospect_datatable;
        // --- start dataset for v-data-table
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}